export const CREATE_PLAN_BEGIN = "CREATE_PLAN_BEGIN"
export const CREATE_PLAN_SUCCESS = "CREATE_PLAN_SUCCESS"
export const CREATE_PLAN_FAILURE = "CREATE_PLAN_FAILURE"

export const FETCH_PLAN_BEGIN = "FETCH_PLAN_BEGIN"
export const FETCH_PLAN_SUCCESS = "FETCH_PLAN_SUCCESS"
export const FETCH_PLAN_FAILURE = "FETCH_PLAN_FAILURE"

export const FETCH_PLANS_ANSWERS_BEGIN = "FETCH_PLANS_ANSWERS_BEGIN"
export const FETCH_PLANS_ANSWERS_SUCCESS = "FETCH_PLANS_ANSWERS_SUCCESS"
export const FETCH_PLANS_ANSWERS_FAILURE = "FETCH_PLANS_ANSWERS_FAILURE"

export const SAVE_ABOUT_ME_BEGIN = "SAVE_ABOUT_ME_BEGIN"
export const SAVE_ABOUT_ME_SUCCESS = "SAVE_ABOUT_ME_SUCCESS"
export const SAVE_ABOUT_ME_FAILURE = "SAVE_ABOUT_ME_FAILURE"

export const SAVE_SUPPORT_TEAM_BEGIN = "SAVE_SUPPORT_TEAM_BEGIN"
export const SAVE_SUPPORT_TEAM_SUCCESS = "SAVE_SUPPORT_TEAM_SUCCESS"
export const SAVE_SUPPORT_TEAM_FAILURE = "SAVE_SUPPORT_TEAM_FAILURE"

export const SAVE_COMMUNITY_ACTIVITIES_BEGIN = "SAVE_COMMUNITY_ACTIVITIES_BEGIN"
export const SAVE_COMMUNITY_ACTIVITIES_SUCCESS =
  "SAVE_COMMUNITY_ACTIVITIES_SUCCESS"
export const SAVE_COMMUNITY_ACTIVITIES_FAILURE =
  "SAVE_COMMUNITY_ACTIVITIES_FAILURE"

export const SAVE_MY_GOALS_BEGIN = "SAVE_MY_GOALS_BEGIN"
export const SAVE_MY_GOALS_SUCCESS = "SAVE_MY_GOALS_SUCCESS"
export const SAVE_MY_GOALS_FAILURE = "SAVE_MY_GOALS_FAILURE"

export const SAVE_REQUIRED_SERVICES_BEGIN = "SAVE_REQUIRED_SERVICES_BEGIN"
export const SAVE_REQUIRED_SERVICES_SUCCESS = "SAVE_REQUIRED_SERVICES_SUCCESS"
export const SAVE_REQUIRED_SERVICES_FAILURE = "SAVE_REQUIRED_SERVICES_FAILURE"

export const DELETE_SUPPORT_TEAM_BEGIN = "DELETE_SUPPORT_TEAM_BEGIN"
export const DELETE_SUPPORT_TEAM_SUCCESS = "DELETE_SUPPORT_TEAM_SUCCESS"
export const DELETE_SUPPORT_TEAM_FAILURE = "DELETE_SUPPORT_TEAM_FAILURE"

export const DELETE_REQUIRED_SERVICES_BEGIN = "DELETE_REQUIRED_SERVICES_BEGIN"
export const DELETE_REQUIRED_SERVICES_SUCCESS =
  "DELETE_REQUIRED_SERVICES_SUCCESS"
export const DELETE_REQUIRED_SERVICES_FAILURE =
  "DELETE_REQUIRED_SERVICES_FAILURE"

export const FILE_UPLOAD_BEGIN = "FILE_UPLOAD_BEGIN"
export const FILE_UPLOAD_SUCCESS = "FILE_UPLOAD_SUCCESS"
export const FILE_UPLOAD_FAILURE = "FILE_UPLOAD_FAILURE"

export const FETCH_SUPPORT_REQUEST_BEGIN = "FETCH_SUPPORT_REQUEST_BEGIN"
export const FETCH_SUPPORT_REQUEST_SUCCESS = "FETCH_SUPPORT_REQUEST_SUCCESS"
export const FETCH_SUPPORT_REQUEST_FAILURE = "FETCH_SUPPORT_REQUEST_FAILURE"

export const SAVE_SUPPORT_REQUEST_BEGIN = "SAVE_SUPPORT_REQUEST_BEGIN"
export const SAVE_SUPPORT_REQUEST_SUCCESS = "SAVE_SUPPORT_REQUEST_SUCCESS"
export const SAVE_SUPPORT_REQUEST_FAILURE = "SAVE_SUPPORT_REQUEST_FAILURE"

export const TOGGLE_ENDORSEMENT_BEGIN = "TOGGLE_ENDORSEMENT_BEGIN"
export const TOGGLE_ENDORSEMENT_SUCCESS = "TOGGLE_ENDORSEMENT_SUCCESS"
export const TOGGLE_ENDORSEMENT_FAILURE = "TOGGLE_ENDORSEMENT_FAILURE"

export const ARCHIVE_SUGGESTIONS_BEGIN = "ARCHIVE_SUGGESTIONS_BEGIN"
export const ARCHIVE_SUGGESTIONS_SUCCESS = "ARCHIVE_SUGGESTIONS_SUCCESS"
export const ARCHIVE_SUGGESTIONS_FAILURE = "ARCHIVE_SUGGESTIONS_FAILURE"

export const CreactePlanBegin = () => ({
  type: CREATE_PLAN_BEGIN
})

export const CreatePlanSuccess = id => ({
  type: CREATE_PLAN_SUCCESS,
  payload: { id }
})

export const CreatePlanFailure = error => ({
  type: CREATE_PLAN_FAILURE,
  payload: { error }
})

export const FetchPlanBegin = () => ({
  type: FETCH_PLAN_BEGIN
})

export const FetchPlanSuccess = id => ({
  type: FETCH_PLAN_SUCCESS,
  payload: { id }
})

export const FetchPlanFailure = error => ({
  type: FETCH_PLAN_FAILURE,
  payload: { error }
})

export const FetchPlansAnswersBegin = () => ({
  type: FETCH_PLANS_ANSWERS_BEGIN
})

export const FetchPlansAnswersSuccess = answers => ({
  type: FETCH_PLANS_ANSWERS_SUCCESS,
  payload: { answers }
})

export const FetchPlansAnswersFailure = error => ({
  type: FETCH_PLANS_ANSWERS_FAILURE,
  payload: { error }
})

export const SaveAboutMeBegin = () => ({
  type: SAVE_ABOUT_ME_BEGIN
})

export const SaveAboutMeSuccess = answers => ({
  type: SAVE_ABOUT_ME_SUCCESS,
  payload: { answers }
})

export const SaveAboutMeFailure = error => ({
  type: SAVE_ABOUT_ME_FAILURE,
  payload: { error }
})

export const SaveSupportTeamBegin = () => ({
  type: SAVE_SUPPORT_TEAM_BEGIN
})

export const SaveSupportTeamSuccess = answers => ({
  type: SAVE_SUPPORT_TEAM_SUCCESS,
  payload: { answers }
})

export const SaveSupportTeamFailure = error => ({
  type: SAVE_SUPPORT_TEAM_FAILURE,
  payload: { error }
})

export const SaveCommunityActiviesBegin = () => ({
  type: SAVE_COMMUNITY_ACTIVITIES_BEGIN
})

export const SaveCommunityActiviesSuccess = answers => ({
  type: SAVE_COMMUNITY_ACTIVITIES_SUCCESS,
  payload: { answers }
})

export const SaveCommunityActiviesFailure = error => ({
  type: SAVE_COMMUNITY_ACTIVITIES_FAILURE,
  payload: { error }
})

export const SaveMyGoalsBegin = () => ({
  type: SAVE_MY_GOALS_BEGIN
})

export const SaveMyGoalsSuccess = answers => ({
  type: SAVE_MY_GOALS_SUCCESS,
  payload: { answers }
})

export const SaveMyGoalsFailure = error => ({
  type: SAVE_MY_GOALS_FAILURE,
  payload: { error }
})

export const SaveRequiredServicesBegin = () => ({
  type: SAVE_REQUIRED_SERVICES_BEGIN
})

export const SaveRequiredServicesSuccess = answers => ({
  type: SAVE_REQUIRED_SERVICES_SUCCESS,
  payload: { answers }
})

export const SaveRequiredServicesFailure = error => ({
  type: SAVE_REQUIRED_SERVICES_FAILURE,
  payload: { error }
})

export const DeleteSupportTeamBegin = () => ({
  type: DELETE_SUPPORT_TEAM_BEGIN
})

export const DeleteSupportTeamSuccess = answers => ({
  type: DELETE_SUPPORT_TEAM_SUCCESS,
  payload: { answers }
})

export const DeleteSupportTeamFailure = error => ({
  type: DELETE_SUPPORT_TEAM_FAILURE,
  payload: { error }
})

export const DeleteRequiredServicesBegin = () => ({
  type: DELETE_REQUIRED_SERVICES_BEGIN
})

export const DeleteRequiredServicesSuccess = answers => ({
  type: DELETE_REQUIRED_SERVICES_SUCCESS,
  payload: { answers }
})

export const DeleteRequiredServicesFailure = error => ({
  type: DELETE_REQUIRED_SERVICES_FAILURE,
  payload: { error }
})

export const FileUploadBegin = () => ({
  type: FILE_UPLOAD_BEGIN
})

export const FileUploadSuccess = () => ({
  type: FILE_UPLOAD_SUCCESS
})

export const FileUploadFailure = () => ({
  type: FILE_UPLOAD_FAILURE
})

export const FetchSupportRequestBegin = () => ({
  type: FETCH_SUPPORT_REQUEST_BEGIN
})

export const FetchSupportRequestSuccess = requests => ({
  type: FETCH_SUPPORT_REQUEST_SUCCESS,
  payload: { requests }
})

export const FetchSupportRequestFailure = error => ({
  type: FETCH_SUPPORT_REQUEST_FAILURE,
  payload: { error }
})

export const SaveSupportRequestBegin = () => ({
  type: SAVE_SUPPORT_REQUEST_BEGIN
})

export const SaveSupportRequestSuccess = message => ({
  type: SAVE_SUPPORT_REQUEST_SUCCESS,
  payload: { message }
})

export const SaveSupportRequestFailure = error => ({
  type: SAVE_SUPPORT_REQUEST_FAILURE,
  payload: { error }
})

export const ToggleEndorsementBegin = () => ({
  type: TOGGLE_ENDORSEMENT_BEGIN
})

export const ToggleEndorsementSuccess = () => ({
  type: TOGGLE_ENDORSEMENT_SUCCESS
})

export const ToggleEndorsementFailure = () => ({
  type: TOGGLE_ENDORSEMENT_FAILURE
})

export const ArchiveSuggestionsBegin = () => ({
  type: ARCHIVE_SUGGESTIONS_BEGIN
})

export const ArchiveSuggestionsSuccess = () => ({
  type: ARCHIVE_SUGGESTIONS_SUCCESS
})

export const ArchiveSuggestionsFailure = () => ({
  type: ARCHIVE_SUGGESTIONS_FAILURE
})
